module.exports = __webpack_public_path__ + "fonts/SofiaSansCondensed-Italic-VariableFont_wght.c9e787c5.ttf";